import type { TraceState } from "./state";
import type { Trace, Span } from "@/models/traces";

/**
 * Retrieve the Trace's filename.
 * @param state - Vuex state for the Trace module.
 * @returns String with the encoded filename or null otherwise.
 */
export function getFilename(state: TraceState): string | undefined {
  return state.filename || undefined;
}

/**
 * Retrieve the Trace's Trace object.
 * @param state - Vuex state for the Trace module.
 * @returns Trace object saved inside the Vuex state or null otherwise.
 */
export function getTrace(state: TraceState): Trace | undefined {
  return state.trace || undefined;
}

/**
 * Retrieve the Trace's associated Spans.
 * @param state - Vuex state for the Trace module.
 * @returns  Array of Spans objects
 */
export function getSpans(state: TraceState): Array<Span> {
  return state.spans || [];
}
